/* eslint-disable react/display-name */
import React from 'react';
import { Messages } from '../../../../../../gen-src/Localize';
import { TypedColumn, TypedBodyCellProps } from '../../dataGrid/TypedDataGridInterfaces';
import { DataQualityIconHeaderCertificationFormatterFactory } from '../../dataGrid/headerFormatters/LabelIconHeaderFormatFactory';
import { SiteUrlsContext } from '../../urls/SiteUrlsContext';
import { IconCellWrapper } from '../Styles';
import { useRenderLabels, UseRenderLabelsParams } from '../hook/useRenderLabels';
import { LabelCellFormatterParams, LabelColumnFormatterParams } from '../shared/LabelCellFormatterParams';

export function createCertificationColumnFormatter<T,>({ getPropsFromRowData, overrides }: LabelColumnFormatterParams<T, UseRenderLabelsParams>): TypedColumn<T, ''> {
  return ({
    name: 'label-certification',
    dataKey: '',
    headerText: '',
    resizable: false,
    sortable: false,
    headerTooltip: Messages.ColumnHeaderCertification(),
    headerFormatter: DataQualityIconHeaderCertificationFormatterFactory,
    cellFormatter: createCertificationCellFormatter<T>({ getPropsFromRowData }),
    ...overrides,
  });
}

function createCertificationCellFormatter<T>({ getPropsFromRowData }: LabelCellFormatterParams<T, UseRenderLabelsParams>): React.Factory<TypedBodyCellProps<T>> {
  return (cellFormatterProps: TypedBodyCellProps<T>) => {
    const props: UseRenderLabelsParams = getPropsFromRowData(cellFormatterProps.row.data);
    return <CertificationCellFormatter {...props} />
  }
}

function CertificationCellFormatter(props: UseRenderLabelsParams): JSX.Element {
  const siteUrls = React.useContext(SiteUrlsContext);
  const { certifications } = useRenderLabels({
    controls: { kind: 'icon', siteUrls: (props.controls && 'siteUrls' in props.controls) ? props.controls?.siteUrls : siteUrls },
    ...props
  });
  return (
    <IconCellWrapper>
      {certifications}
    </IconCellWrapper>
  )
}
